module.exports = __webpack_public_path__ + "static/media/iconChallenge.dd1094a9.svg";